module.exports = __webpack_public_path__ + "assets/img/smartTV-icon4.14a4f7c2.png";